export const RadioSVG = (props: any) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={48} height={48} viewBox="0 0 32 32" {...props}>
        <g id="Rectangle_656" data-name="Rectangle 656" fill="#fff" stroke="#ced4da" strokeWidth="1">
            <rect width="32" height="32" rx="16" stroke="none" />
            <rect x="0.5" y="0.5" width="31" height="31" rx="15.5" fill="none" />
        </g>
    </svg>
);
